define('viewModels/privileged/qm/CustomerJourneyDetailsView',[
    'lib/knockout',
    'lib/lodash4',
    'config',
    'viewModels/ViewModel',
    'services/localeService'
], function(
    ko,
    _,
    config,
    ViewModel,
    localeService
) {
    'use strict';

    var JOURNEY_BASE_URL = config.journey.uri;
    var JOURNEY_PURECLOUD_LAUNCHER_WIDGET_PATH = '/gadgets/v0/integration/purecloud-launcher/';
    var CUSTOMER_JOURNEY_FRAME_SELECTOR = 'iframe.customer-journey-details__iframe';

    /**
     * @param  {function} callback returned if origins are the same and is specified
     * @param  {function} fallback returned if origins are not the same and is specified
     * @returns {function} callback, fallback, or _.noop
     */
    var whenOriginsMatch = function (callback, fallback) {
        var journeyOrigin = JOURNEY_BASE_URL.replace(config.journey.path, '');
        if (window.origin === journeyOrigin) {
            return _.isFunction(callback) ? callback : _.noop;
        }
        return _.isFunction(fallback) ? fallback : _.noop;
    };

    return ViewModel.extend(function CustomerJourneyView(journeyContext, navigateToJourneys) {
        var self = this;
        var appLocale = localeService.getAppLocale();
        var customerId = journeyContext.journeyCustomerId;
        var customerIdType = journeyContext.journeyCustomerIdType;
        var customerSessionId = journeyContext.journeyCustomerSessionId;
        var customerSessionIdType = journeyContext.journeyCustomerSessionIdType;
        var sharedQueryParams = [
            ['customerId', customerId],
            ['customerIdType', customerIdType],
            ['locale', appLocale]
        ];
        var queryParams = customerSessionIdType === 'web' ?
            sharedQueryParams.concat([
                ['visitId', customerSessionId]
            ]) :
            sharedQueryParams.concat([
                ['sessionId',  customerSessionId],
                ['sessionType', customerSessionIdType]
            ]);
        var queryString = _.reduce(queryParams, function(queryAccumulator, queryKeyValue) {
            var queryKey = queryKeyValue[0];
            var queryValue = queryKeyValue[1];
            var queryComponent = encodeURIComponent(queryKey) + '=' + encodeURIComponent(queryValue);
            return queryAccumulator === '?' ?
                queryAccumulator + queryComponent :
                queryAccumulator + '&' + queryComponent;
        }, '?');

        self.journeyUrl = JOURNEY_BASE_URL + JOURNEY_PURECLOUD_LAUNCHER_WIDGET_PATH + queryString;

        self.navigateToJourneys = navigateToJourneys;

        // sets journey frame element height to its inner document scrollHeight
        // TODO: turn resizeJourneyFrame, handleLoaded, and onDispose into a reusable abstraction
        self.resizeJourneyFrame = whenOriginsMatch(function () {
            var journeyFrame = document.querySelector(CUSTOMER_JOURNEY_FRAME_SELECTOR);
            var journeyDocument = journeyFrame.contentDocument;
            var oldHeight = journeyFrame.scrollHeight;
            var newHeight = journeyDocument.body.scrollHeight;
            if (newHeight !== oldHeight) {
                journeyFrame.style.height = newHeight + 'px';
            }
        });

        // called when the DOMContentLoaded fires for the journey frame
        // cannot add resize listener unless origins match due to same-origin policy.
        self.handleLoaded = whenOriginsMatch(function () {
            var journeyFrame = document.querySelector(CUSTOMER_JOURNEY_FRAME_SELECTOR);
            journeyFrame.contentWindow.addEventListener('resize', self.resizeJourneyFrame);
        });

        self.onDispose = whenOriginsMatch(function () {
            var journeyFrame = document.querySelector(CUSTOMER_JOURNEY_FRAME_SELECTOR);
            journeyFrame.contentWindow.removeEventListener('resize', self.resizeJourneyFrame);
        });
    });
});
